var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDevelopment)?_c('div',{staticClass:"development-banner",attrs:{"role":"status"}},[_c('strong',[_vm._v("DEVELOPMENT SITE")]),_c('span',[_vm._v("Changes here do not affect the live website.")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }